"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.99037655,10 L4.99176025,13.979126 L11.3137085,8.34314575 L4.98760057,2.01703815 L4.9889856,6 L2.4492936e-16,6 L0,10 L4.99037655,10 L4.99037655,10 Z M14,2 L14,14 L9,14 L9,16 L15,16 L16,16 L16,1 L16,1.77635684e-15 L9,0 L9,2 L14,2 L14,2 Z"
  }));
};

exports["default"] = _default;